var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 13.8125V23.4688C12.2188 24.2972 12.8903 24.9688 13.7188 24.9688H20.2812C21.1097 24.9688 21.7812 24.2972 21.7812 23.4688V13.8125H12.2188Z",
    fill: "#3E97FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5938 11.0234V10.8281C18.5938 10.2758 18.146 9.82812 17.5938 9.82812H16.4063C15.854 9.82812 15.4063 10.2758 15.4063 10.8281V11.0234H11.9219C11.6457 11.0234 11.4219 11.2473 11.4219 11.5234V11.7188C11.4219 11.9949 11.6457 12.2188 11.9219 12.2188H22.0781C22.3543 12.2188 22.5781 11.9949 22.5781 11.7188V11.5234C22.5781 11.2473 22.3543 11.0234 22.0781 11.0234H18.5938Z",
    fill: "#3E97FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/deleteButton.af7a915432396ce71173951e1a140def.svg";
export { ForwardRef as ReactComponent };